import ErrorComponent from '../../components/Error';

export default function Error() {
  return <ErrorComponent />;
}
